import React from 'react';
import { Box, Spinner } from '@amzn/awsui-components-react';

/**
 * EmbedImage - Renders an image file from a presigned URL.
 * Supports all browser-native image types: png, jpg, jpeg, gif, bmp, svg, webp, ico, tiff.
 *
 * Props:
 *   fileUrl (string)  - presigned S3 URL to the image file
 *   fileName (string) - original file name (used for alt text)
 */
const EmbedImage = ({ fileUrl, fileName = 'image' }) => {
  if (!fileUrl) {
    return <Box padding="l"><Spinner /> Loading image...</Box>;
  }

  return (
    <Box padding="s" textAlign="center">
      <img
        src={fileUrl}
        alt={fileName}
        style={{
          maxWidth: '100%',
          maxHeight: '800px',
          objectFit: 'contain',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
        }}
      />
    </Box>
  );
};

export default EmbedImage;
